exports = module.exports = require("../../../../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.header-text[data-v-58f09720]{\r\n  font-size: 13px;\r\n  color: slategrey;\n}\nmain[data-v-58f09720]{\r\n  font-size: 12px;\r\n  color: #909399;\r\n  padding-top: 20px;\n}\n.flex[data-v-58f09720]{\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\n}\n.fh-50[data-v-58f09720]{\r\n  height: 50px;\r\n  line-height: 50px;\r\n  border-bottom: 1px solid #d3d3d3;\n}\n.c-p[data-v-58f09720]{\r\n  cursor: pointer;\n}\r\n", ""]);

// exports
